export function Sprout({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 391.51 287.936"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <ellipse
          cx="156.5"
          cy="206.936"
          rx="43.5"
          ry="16"
          fill="#FFFA60"
          fillOpacity="0.22"
        />
        <g filter="url(#sprout-f0)">
          <ellipse
            cx="156.5"
            cy="211.936"
            rx="126.5"
            ry="46"
            fill="url(#sprout-r0)"
          />
        </g>
        <g filter="url(#sprout-f1)">
          <ellipse
            cx="156.14"
            cy="206.675"
            rx="10.7787"
            ry="3.9522"
            fill="#424242"
            fillOpacity="0.17"
          />
        </g>
        <g>
          <path
            d="M155.623 166.423C156.204 166.371 156.952 166.549 157.54 166.734C158.146 166.924 158.543 167.492 158.603 168.124C160.502 188.284 161.202 197.706 164.748 204.369C166.625 207.894 159.102 208.945 155.79 208.945C153.176 208.945 148.676 207.437 149.011 205.169C150.037 198.221 151.36 191.599 151.733 183.97C151.966 179.194 152.218 174.022 152.674 168.13C152.724 167.491 153.122 166.922 153.733 166.729C154.315 166.546 155.05 166.372 155.623 166.423Z"
            fill="#4EFEB4"
          />
          <path
            d="M155.623 166.423C156.204 166.371 156.952 166.549 157.54 166.734C158.146 166.924 158.543 167.492 158.603 168.124C160.502 188.284 161.202 197.706 164.748 204.369C166.625 207.894 159.102 208.945 155.79 208.945C153.176 208.945 148.676 207.437 149.011 205.169C150.037 198.221 151.36 191.599 151.733 183.97C151.966 179.194 152.218 174.022 152.674 168.13C152.724 167.491 153.122 166.922 153.733 166.729C154.315 166.546 155.05 166.372 155.623 166.423Z"
            fill="url(#sprout-r1)"
          />
        </g>
        <g>
          <path
            d="M221.895 116.126C223.95 116.739 225.12 118.759 224.661 120.854C222.804 129.325 216.285 151.125 196.375 166.075C186.161 173.745 165.869 177.081 156.335 178.271C153.552 178.619 151.19 176.429 151.369 173.631C151.995 163.83 154.486 142.632 164.39 131.815C185.961 108.256 212.568 113.344 221.895 116.126Z"
            fill="url(#sprout-r2)"
          />
          <path
            d="M221.895 116.126C223.95 116.739 225.12 118.759 224.661 120.854C222.804 129.325 216.285 151.125 196.375 166.075C186.161 173.745 165.869 177.081 156.335 178.271C153.552 178.619 151.19 176.429 151.369 173.631C151.995 163.83 154.486 142.632 164.39 131.815C185.961 108.256 212.568 113.344 221.895 116.126Z"
            fill="url(#sprout-r3)"
            fillOpacity="0.12"
          />
        </g>
        <g>
          <path
            d="M99.996 129.2C97.4874 129.7 96.201 132.241 97.2047 134.594C100.25 141.732 107.966 156.454 123.439 167.872C130.915 173.388 145.068 176.878 152.996 178.492C155.963 179.096 158.57 176.732 158.171 173.731C157.103 165.69 154.15 151.278 146.281 143.383C128.91 125.958 108.735 127.457 99.996 129.2Z"
            fill="url(#sprout-r4)"
          />
          <path
            d="M99.996 129.2C97.4874 129.7 96.201 132.241 97.2047 134.594C100.25 141.732 107.966 156.454 123.439 167.872C130.915 173.388 145.068 176.878 152.996 178.492C155.963 179.096 158.57 176.732 158.171 173.731C157.103 165.69 154.15 151.278 146.281 143.383C128.91 125.958 108.735 127.457 99.996 129.2Z"
            fill="url(#sprout-r5)"
            fillOpacity="0.12"
          />
        </g>
        <path
          d="M163.355 156.209C163.291 156.324 163.261 156.458 163.282 156.589C163.303 156.721 163.372 156.838 163.475 156.917C163.578 156.996 163.709 157.031 163.842 157.017C163.974 157.003 164.096 156.939 164.189 156.847C164.799 156.241 165.386 155.657 165.985 155.054C168.354 152.674 170.67 150.287 173.001 147.956C181.084 139.665 191.541 134.151 202.139 129.101C202.909 128.734 203.646 128.384 204.425 128.018C204.548 127.96 204.647 127.859 204.699 127.731C204.75 127.604 204.75 127.463 204.697 127.337C204.645 127.212 204.545 127.111 204.419 127.058C204.293 127.005 204.151 127.003 204.023 127.049C203.212 127.344 202.442 127.626 201.64 127.928C190.651 132.04 179.496 137.294 171.022 145.977C168.595 148.403 166.483 151.13 164.671 154.009C164.211 154.737 163.784 155.457 163.355 156.209Z"
          fill="#218D5C"
          fillOpacity="0.26"
        />
        <path
          d="M143.019 157.987C143.071 158.103 143.095 158.234 143.073 158.361C143.051 158.488 142.986 158.601 142.887 158.676C142.789 158.752 142.664 158.786 142.535 158.775C142.407 158.764 142.287 158.707 142.188 158.627C141.797 158.31 141.424 158.004 141.048 157.685C139.561 156.425 138.179 155.127 136.85 153.814C132.253 149.149 126.331 145.998 120.262 142.982C119.821 142.764 119.4 142.554 118.955 142.336C118.835 142.276 118.736 142.176 118.685 142.051C118.633 141.925 118.631 141.786 118.68 141.662C118.73 141.538 118.826 141.437 118.95 141.382C119.074 141.326 119.214 141.321 119.342 141.36C119.819 141.508 120.271 141.649 120.742 141.802C127.188 143.873 133.817 146.758 138.817 151.824C140.245 153.234 141.426 154.873 142.359 156.635C142.596 157.081 142.81 157.523 143.019 157.987Z"
          fill="#218D5C"
          fillOpacity="0.26"
        />
        <g>
          <g filter="url(#sprout-f2)">
            <ellipse
              cx="189.64"
              cy="195.288"
              rx="3.18067"
              ry="4.04813"
              transform="rotate(27 189.64 195.288)"
              fill="#FFFDB6"
              style={{ mixBlendMode: 'overlay' }}
              shapeRendering="crispEdges"
            />
          </g>
          <g opacity="0.8" filter="url(#sprout-f3)">
            <ellipse
              cx="368.863"
              cy="92.7307"
              rx="3.66059"
              ry="4.65894"
              transform="rotate(27 368.863 92.7307)"
              fill="#FFFDB6"
              fillOpacity="0.84"
              style={{ mixBlendMode: 'overlay' }}
              shapeRendering="crispEdges"
            />
          </g>
          <g filter="url(#sprout-f4)">
            <ellipse
              cx="135.988"
              cy="203.503"
              rx="4.09482"
              ry="5.21159"
              transform="rotate(27 135.988 203.503)"
              fill="#FFFDB6"
              style={{ mixBlendMode: 'overlay' }}
              shapeRendering="crispEdges"
            />
          </g>
          <g opacity="0.8" filter="url(#sprout-f5)">
            <ellipse
              cx="193.59"
              cy="209.91"
              rx="2.46203"
              ry="3.13349"
              transform="rotate(27 193.59 209.91)"
              fill="#FFFDB6"
              fillOpacity="0.84"
              style={{ mixBlendMode: 'overlay' }}
              shapeRendering="crispEdges"
            />
          </g>
          <g opacity="0.8" filter="url(#sprout-f6)">
            <ellipse
              cx="210.51"
              cy="177.742"
              rx="1.72674"
              ry="2.19767"
              transform="rotate(27 210.51 177.742)"
              fill="#FFFDB6"
              fillOpacity="0.84"
              style={{ mixBlendMode: 'overlay' }}
              shapeRendering="crispEdges"
            />
          </g>
          <g opacity="0.8" filter="url(#sprout-f7)">
            <ellipse
              cx="147.51"
              cy="211.742"
              rx="1.72674"
              ry="2.19767"
              transform="rotate(27 147.51 211.742)"
              fill="#FFFDB6"
              fillOpacity="0.84"
              style={{ mixBlendMode: 'overlay' }}
              shapeRendering="crispEdges"
            />
          </g>
          <g opacity="0.8" filter="url(#sprout-f8)">
            <ellipse
              cx="116.604"
              cy="196.845"
              rx="1.79125"
              ry="2.27978"
              transform="rotate(27 116.604 196.845)"
              fill="#FFFDB6"
              fillOpacity="0.84"
              style={{ mixBlendMode: 'overlay' }}
              shapeRendering="crispEdges"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="sprout-f0"
          x="0"
          y="135.936"
          width="313"
          height="152"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="15" result="effect1_foregroundBlur" />
        </filter>
        <filter
          id="sprout-f1"
          x="143.636"
          y="200.998"
          width="25.0067"
          height="11.3536"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.862299"
            result="effect1_foregroundBlur"
          />
        </filter>
        <filter
          id="sprout-f2"
          x="166.334"
          y="171.475"
          width="46.6112"
          height="47.6274"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="9.96373" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.952941 0 0 0 0 0.588235 0 0 0 1 0"
          />
          <feBlend
            mode="hard-light"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="sprout-f3"
          x="346.216"
          y="69.4988"
          width="45.2941"
          height="46.4637"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="9.3796" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.952941 0 0 0 0 0.588235 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="sprout-f4"
          x="122.239"
          y="189.099"
          width="27.4981"
          height="28.8064"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.7" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.952941 0 0 0 0 0.588235 0 0 0 1 0"
          />
          <feBlend
            mode="hard-light"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="sprout-f5"
          x="182.126"
          y="198.053"
          width="22.9276"
          height="23.7142"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.42446" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.952941 0 0 0 0 0.588235 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="sprout-f6"
          x="199.827"
          y="166.783"
          width="21.3657"
          height="21.9174"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.42446" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.952941 0 0 0 0 0.588235 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="sprout-f7"
          x="136.827"
          y="200.783"
          width="21.3657"
          height="21.9174"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.42446" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.952941 0 0 0 0 0.588235 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <filter
          id="sprout-f8"
          x="95.9428"
          y="175.897"
          width="41.3233"
          height="41.8956"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="9.3796" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.964706 0 0 0 0 0.952941 0 0 0 0 0.588235 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
        <radialGradient
          id="sprout-r0"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(157.117 211.936) scale(107.988 38.7013)"
        >
          <stop stopColor="#F6F396" />
          <stop offset="1" stopColor="#FFFA60" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="sprout-r1"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-6.58464e-07 40.4191 -110.148 -163.493 157.125 150.353)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00482243" stopColor="#2F986C" />
          <stop offset="1" stopColor="#4EFEB4" />
        </radialGradient>
        <radialGradient
          id="sprout-r2"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(164.748 180.793) rotate(-29.0064) scale(69.2496 123.263)"
        >
          <stop stopColor="#4FFFB0" />
          <stop offset="0.995178" stopColor="#3AF5E7" />
        </radialGradient>
        <radialGradient
          id="sprout-r3"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(181.365 133.021) rotate(85.4752) scale(50.0976 70.5676)"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="sprout-r4"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-51.1225 -27.2992 -44.0829 76.1487 148.271 179.028)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4FFFB0" />
          <stop offset="0.995178" stopColor="#3AF5E7" />
        </radialGradient>
        <radialGradient
          id="sprout-r5"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-0.979588 36.3506 57.8701 7.25189 132.502 143.334)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0" />
          <stop offset="1" />
        </radialGradient>
      </defs>
    </svg>
  )
}
